import React, { useState } from "react";
import { SubtitleContext } from "../../contexts/SubtitleContext";
import { LinkButton } from "rc-easyui";
import Popup from "reactjs-popup";
import TimeUtils from "../../helper/TimeUtils";
import DataObj from "../../class/DataObj";
import MathUtils from "../../helper/MathUtils";

const AdjustFrameGap_Popup = ({ _WaveformView }) => {
  //網址判斷
  //     useEffect(() => {
  //
  //     }, [location]);

  const [startGap, setStartGap] = useState(2);
  const [endGap, setEndGap] = useState(11);

  //搜尋錯誤影格
  const searchFrameGapError = async () => {};

  return (
    <Popup
      open={_WaveformView.state.isShowAdjustFrameGapError}
      modal
      closeOnDocumentClick
      onClose={() => {
        _WaveformView.setState({ isShowAdjustFrameGapError: false });
      }}
      contentStyle={{ width: "450px" }}
    >
      <SubtitleContext.Consumer>
        {(context) => (
          <div
            title="Find Frame Split"
            style={{ width: "450px" }}
            ref={(ref) => (_WaveformView.dlg = ref)}
          >
            <h3>Start Adjust Frame Gap Error?</h3>
            <form className=" ">
              <div className="form-group">
                <label htmlFor="inputAddress">Start: </label>

                <input
                  id="fFrameSplit"
                  style={{ width: "30px" }}
                  type="text"
                  placeholder="Frame Split"
                  value={startGap}
                  onChange={(event) => {
                    if (isNaN(event.target.value) === true) {
                    } else {
                      setStartGap(event.target.value);
                    }
                  }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="inputAddress">End: </label>

                <input
                  id="fFrameSplit"
                  style={{ width: "30px" }}
                  type="text"
                  placeholder="Frame Split"
                  value={endGap}
                  onChange={(event) => {
                    if (isNaN(event.target.value) === true) {
                    } else {
                      setEndGap(event.target.value);
                    }
                  }}
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <LinkButton
                  onClick={async () => {
                    // //開始搜尋

                    await _WaveformView.setState({
                      isShowFindFrameGapList: false,
                    });

                    await _WaveformView.setState({ loading: true });
                    await _WaveformView.setState({
                      loading: false,
                      isShowTranslationsNavbarAlert: false,
                    });

                    let stringData = _WaveformView.DataObjArray.getContent();

                    let newTarget = [];
                    stringData.forEach(function (qdata, index) {
                      let ROWoBJ = new DataObj(qdata);

                      // 只有最後一個沒有間距
                      if (index !== stringData.length - 1) {
                        //當下資料
                        const currentIn = ROWoBJ.In;
                        const currentOut = ROWoBJ.Out;

                        //下一個
                        const nextROWoBJ = new DataObj(stringData[index + 1]);
                        const nextIn = nextROWoBJ.In;

                        //當下frame
                        const beginFrameNumber =
                          TimeUtils.timeString_convertTo_frame(currentIn);
                        const currentFrame =
                          TimeUtils.timeString_convertTo_frame(currentOut);

                        //下一個frame
                        const nextFrame =
                          TimeUtils.timeString_convertTo_frame(nextIn);

                        //計算
                        const countFrameNumber =
                          parseFloat(nextFrame) - parseFloat(currentFrame);

                        //console.log(`durationFrame  ${currentFrame} - ${beginFrameNumber} = ${durationFrame}  `);

                        if (
                          parseFloat(currentFrame) === 0 ||
                          parseFloat(beginFrameNumber) === 0
                        ) {
                          return;
                        }

                        if (nextROWoBJ.In === "") {
                          return;
                        }
 
                        if (
                          !MathUtils.checkFrameGapIsError(
                            countFrameNumber,
                            startGap,
                            endGap
                          )
                        ) {
                          //沒錯 => 過關
                        } else {
                          //  const endFrame = In_next_frame - 2;
                          //
                          //  // dataObj.setInOut("Out",finalSecond);
                          // dataObj.setInOut("Out",TimeUtils.getTimeStringFrom_FrameCount(endFrame,TimeUtils.getFPS()));
                          //
                          // stringData[index] = dataObj;
                          // _WaveformView.DataObjArray.updateDataObj_by_index(index,dataObj);
                          // _WaveformView.UpdateSpecificGraySquare_Size(index);

                          //原 有進位問題
                          //const endFrame = parseFloat(nextFrame) - 2;
                          //ROWoBJ.setInOut("Out",TimeUtils.getTimeStringFrom_FrameCount(endFrame,TimeUtils.getFPS()));
                          //新
                          ROWoBJ.setInOut(
                            "Out",
                            TimeUtils.getTimeString_byframeSplitError(
                              nextIn,
                              2,
                              TimeUtils.getFPS()
                            )
                          );

                          stringData[index] = ROWoBJ;

                          _WaveformView.DataObjArray.updateDataObj_by_index(
                            index,
                            ROWoBJ
                          );

                          _WaveformView.UpdateSpecificGraySquare_Size(index);
                        }
                      }
                    });

                    //初始字幕跟拖拉資料
                    _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                      stringData
                    );

                    _WaveformView.setIsEdit(true);

                    //關掉視窗
                    _WaveformView.setState({
                      isShowAdjustFrameGapError: false,
                    });

                    //顯示列表
                    // _WaveformView.setState({isShowFindFrameGapList:true});
                  }}
                >
                  Confirm
                </LinkButton>
              </div>
            </form>
          </div>
        )}
      </SubtitleContext.Consumer>
    </Popup>
  );
};

export default AdjustFrameGap_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/AdjustFrameGap_Popup.js